var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-navigation custom-btn-navigation",on:{"click":_vm.btnLink}},[_c('CircleNav',{attrs:{"isOn":_vm.isOn}}),_c('p',[_vm._v(_vm._s(_vm.btnText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }